export function paginateCustom(array: any[], perPage: number, page: number): any[] {
  return array.slice((page - 1) * perPage, page * perPage);
}
